import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Handshake } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { PageHero } from "@/components/PageHero";
import { api, formatApiErrorDetail } from "@/lib/api";
import { IMG } from "@/lib/assets";

export default function Sponsor() {
  const [form, setForm] = useState({ company: "", contact_name: "", email: "", phone: "", interest: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post("/sponsors", form);
      toast.success(data.message);
      setForm({ company: "", contact_name: "", email: "", phone: "", interest: "", message: "" });
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <main>
      <PageHero overline="Corporate Sponsorship" image={IMG.entrepreneur}
        title="Partner with us to expand opportunity"
        subtitle="Partner with a growing 501(c)(3) foundation committed to transparency. Share your interest and our partnerships team will reach out." />
      <section className="max-w-2xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20">
        <form onSubmit={submit} className="bg-white rounded-3xl border border-slate-200 p-8 shadow-xl space-y-5">
          <div className="grid sm:grid-cols-2 gap-5">
            <div><Label>Company *</Label><Input required value={form.company} onChange={(e) => set("company", e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="sponsor-company" /></div>
            <div><Label>Contact Name *</Label><Input required value={form.contact_name} onChange={(e) => set("contact_name", e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="sponsor-contact" /></div>
            <div><Label>Email *</Label><Input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="sponsor-email" /></div>
            <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => set("phone", e.target.value)} className="mt-2 h-12 rounded-xl" data-testid="sponsor-phone" /></div>
          </div>
          <div><Label>Area of interest</Label><Input value={form.interest} onChange={(e) => set("interest", e.target.value)} placeholder="e.g. Youth mentorship, housing, events" className="mt-2 h-12 rounded-xl" data-testid="sponsor-interest" /></div>
          <div><Label>Message</Label><Textarea value={form.message} onChange={(e) => set("message", e.target.value)} className="mt-2 rounded-xl" data-testid="sponsor-message" /></div>
          <Button type="submit" disabled={loading} data-testid="sponsor-submit" className="w-full h-14 rounded-full bg-navy-900 hover:bg-navy-700 text-white font-bold">
            {loading ? <><Loader2 className="h-5 w-5 mr-2 animate-spin" /> Sending...</> : <><Handshake className="h-5 w-5 mr-2" /> Submit Inquiry</>}
          </Button>
        </form>
      </section>
    </main>
  );
}
